// 로그인 유형(관리자/발행인/가맹점/회비담당) 처리 공용 헬퍼.
// 한 계정이 가맹점(Store)이면서 회비담당(isFeeManager)일 수 있어,
// 로그인 시 선택한 유형(localStorage "loginType")으로 화면을 명시적으로 가른다.

export const LOGIN_TYPES = [
  { id: "Administrator", name: "관리자" },
  { id: "Issuer", name: "발행인" },
  { id: "Store", name: "가맹점" },
  { id: "Manager", name: "기부/회비" },
  { id: "ChargeManager", name: "충전담당" },
];

// 계정이 해당 유형으로 진입할 자격이 있는지(권한 검증)
export const isTypeAllowed = (type, info) => {
  if (!info) return false;
  switch (type) {
    case "Administrator":
      return info.role === "Administrator";
    case "Issuer":
      return info.role === "Issuer";
    case "Store":
      return info.role === "Store";
    case "Manager":
      return Boolean(info.isFeeManager || info.isDonationManager);
    case "ChargeManager":
      return Boolean(info.isChargeManager);
    default:
      return false;
  }
};

// 현재 세션의 화면 유형 결정.
// 선택값(loginType)이 유효하면 그대로, 없거나 무효면 권한 기반 기본값(하위호환).
export const getViewType = (info) => {
  if (!info) return null;
  const stored = localStorage.getItem("loginType");
  if (stored && isTypeAllowed(stored, info)) return stored;

  if (info.role === "Administrator") return "Administrator";
  if (info.role === "Issuer") return "Issuer";
  if (info.isFeeManager || info.isDonationManager) return "Manager";
  if (info.isChargeManager) return "ChargeManager";
  if (info.role === "Store") return "Store";
  return null;
};
